import {
  IonBadge,
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { closeOutline, sparkles } from 'ionicons/icons';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

export interface AiSuggestion {
  id: string;
  title: string;
  detail?: string;
  severity?: 'info' | 'warning' | 'danger';
  href?: string;
}

interface Props {
  suggestions: AiSuggestion[];
}

export function AiSuggestionsFab({ suggestions }: Props): JSX.Element {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  return (
    <>
      <IonFab slot="fixed" vertical="bottom" horizontal="start" style={{ overflow: 'visible' }}>
        <IonFabButton color="tertiary" aria-label="Suggerimenti AI" onClick={() => setOpen(true)}>
          <IonIcon icon={sparkles} />
        </IonFabButton>
        {suggestions.length > 0 && (
          <IonBadge
            color="danger"
            aria-label={`${suggestions.length} suggerimenti da visualizzare`}
            style={{
              position: 'absolute', top: -6, right: -7, zIndex: 2,
              minWidth: 22, height: 22, padding: '0 6px', borderRadius: 999,
              display: 'grid', placeItems: 'center', boxSizing: 'border-box',
              fontSize: 12, fontWeight: 800, lineHeight: 1, pointerEvents: 'none',
            }}
          >
            {suggestions.length > 99 ? '99+' : suggestions.length}
          </IonBadge>
        )}
      </IonFab>

      <IonModal isOpen={open} onDidDismiss={() => setOpen(false)}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Suggerimenti AI</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setOpen(false)} aria-label="chiudi">
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          {suggestions.length === 0 ? (
            <IonText color="medium">
              <p>Nessuna azione prioritaria. Tutto sotto controllo.</p>
            </IonText>
          ) : (
            <IonList>
              {suggestions.map((s) => (
                <IonItem
                  key={s.id}
                  button={!!s.href}
                  onClick={() => {
                    if (s.href) {
                      setOpen(false);
                      history.push(s.href);
                    }
                  }}
                >
                  <IonLabel>
                    <h3>{s.title}</h3>
                    {s.detail && <p>{s.detail}</p>}
                  </IonLabel>
                  {s.severity && (
                    <IonBadge slot="end" color={s.severity === 'danger' ? 'danger' : s.severity === 'warning' ? 'warning' : 'medium'}>
                      !
                    </IonBadge>
                  )}
                </IonItem>
              ))}
            </IonList>
          )}
        </IonContent>
      </IonModal>
    </>
  );
}
